/**
 * Main JavaScript file
 *
 * @package EBNewsletters
 */

import '../scss/style.scss';
import initCollapsibles from './collapse';
import initHeader from './header';
import initNewsletters from './newsletters';

initCollapsibles();
initHeader();
initNewsletters();
